<template>
	<div>
		<div class="tw-text-3xl tw-font-bold">
			{{ $t('integrations.whatsapp-qr-get-qr-code-title', { marketplace: marketplaceName }) }}
		</div>

		<div v-if="qrCode" class="tw-mt-6">
			<div class="tw-flex tw-justify-center">
				<div class="tw-bg-white tw-p-6 tw-rounded-lg tw-shadow-lg">
					<img 
						:src="getQRCodeDataUri" 
						alt="QR Code" 
						class="tw-w-[300px] tw-h-[300px] tw-object-contain"
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import { useLinkMarketplaceStore } from '../../../../stores/link-marketplace';
import { Marketplace } from '../../../../entities/marketplace';
import { Alert } from '@/v2/plugins/alert';

const linkMarketplaceStore = useLinkMarketplaceStore();

const qrCode = ref('');

const marketplaceName = computed(() => {
	return linkMarketplaceStore.marketplace.name || '';
});

const getQRCodeDataUri = computed(() => {
	if (!qrCode.value) return '';
	return `data:image/png;base64,${qrCode.value}`;
});

const onGetQRCode = async () => {
	try {
		const res = await Marketplace.getWhatsAppQRCode({
			session_name: linkMarketplaceStore.whatsappQrSession?.name,
			linked_marketplace_id: linkMarketplaceStore.linkedMarketplaceId,
		});
		if (res.data.success) {
			qrCode.value = res.data.result.qr_code;
		}
	} catch (err) {
		Alert.error(err?.response?.data?.message?.error);
	}
};

onMounted(() => {
	onGetQRCode();
});
</script>
